import React from "react";
import styles from "./PaidEquipmentModal.module.css";
import {
    resolvePaidEquipmentImageSrc,
    formatPricePerPiece,
    paidCategoryHeading,
    groupPaidEquipmentByCategory,
} from "./paidEquipmentHelpers";

const BackIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 6.72018L6.74891 0L7.95099 1.19696L1.20208 7.91714L0 6.72018Z"
            fill="#1F1F1F"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.74978 14L0 6.72018L1.25003 5.57164L7.99894 12.8518L6.74978 14Z"
            fill="#1F1F1F"
        />
    </svg>
);

function stockLabel(q) {
    const n = typeof q === "number" ? q : parseInt(String(q), 10);
    if (!Number.isFinite(n) || n < 0) return null;
    return `${n} Stück`;
}

export const PaidEquipmentModal = ({ items, view, selectedItem, onClose, onBackToList, onSelectItem }) => {
    const groups = groupPaidEquipmentByCategory(items);

    const renderList = () => (
        <div className={styles.body}>
            {groups.map(([categoryKey, categoryItems]) => (
                <section key={categoryKey}>
                    <h3 className={`${styles.categoryHeading} titleSemibold`}>{paidCategoryHeading(categoryKey)}</h3>
                    {categoryItems.map((item, index) => {
                        const key = item.id != null ? String(item.id) : `list-${categoryKey}-${index}`;
                        const title = item.nameModel || item.name || item.title || "Equipment";
                        const img = resolvePaidEquipmentImageSrc(item);
                        const stock = stockLabel(item.quantity ?? item.count);
                        const desc = item.description || "";
                        return (
                            <button
                                key={key}
                                type="button"
                                className={styles.listCard}
                                onClick={() => onSelectItem(item)}
                            >
                                <div className={styles.listThumbWrap}>
                                    {img ? <img src={img} alt="" /> : null}
                                </div>
                                <div className={styles.listInfo}>
                                    <div className={styles.listTitleRow}>
                                        <p className={`${styles.listTitle} regularLarge`}>{title}</p>
                                        {stock ? <span className={`${styles.stockPill} semiboldXxs`}>{stock}</span> : null}
                                    </div>
                                    <p className={`${styles.listPrice} regularSmall`}>
                                        {formatPricePerPiece(item.pricePerPiece ?? item.price)}
                                    </p>
                                </div>
                            </button>
                        );
                    })}
                </section>
            ))}
        </div>
    );

    const renderDetail = () => {
        if (!selectedItem) return null;
        const title = selectedItem.nameModel || selectedItem.name || selectedItem.title || "Equipment";
        const img = resolvePaidEquipmentImageSrc(selectedItem);
        const cat = paidCategoryHeading(selectedItem.category);
        const stock = stockLabel(selectedItem.quantity ?? selectedItem.count);
        const desc = selectedItem.description || "";

        return (
            <div className={styles.body}>
                <div className={styles.detailTop}>
                    <div className={styles.detailImageBox}>{img ? <img src={img} alt={title} /> : null}</div>
                    <div className={styles.detailMeta}>
                        <p className={`${styles.detailCategory} regularSmall`}>{cat}</p>
                        <h2 className={`${styles.detailTitle} titleSemibold3`}>{title}</h2>
                        <div className={styles.priceRow}>
                            <p className={`${styles.detailPrice} regularMiddle`}>
                                {formatPricePerPiece(selectedItem.pricePerPiece ?? selectedItem.price)}
                            </p>
                            {stock ? <span className={`${styles.detailStockPill} semiboldXxs`}>{stock}</span> : null}
                        </div>
                    </div>
                </div>
                {desc ? (
                    <div className={styles.descBlock}>
                        <h3 className={`${styles.descHeading} semiboldMiddle`}>Beschreibung</h3>
                        <p className={`${styles.descText} regularLarge`}>{desc}</p>
                    </div>
                ) : null}
            </div>
        );
    };

    return (
        <div className={styles.root}>
            <header className={styles.header}>
                <div className={styles.headerSide}>
                    {view === "detail" ? (
                        <>
                            <button type="button" className={styles.backBtn} onClick={onBackToList} aria-label="Zurück">
                                <BackIcon />
                            </button>
                            <h2 className={`${view === "list" ? styles.headerTitleCentered : ""} mediumLarge`}>
                                {view === "list" ? `Alle Equipments (${items.length})` : "Alle Equipments"}
                            </h2>
                        </>
                    ) : (
                        <>
                            <span className={styles.headerSideSpacer} aria-hidden />
                            <h2 className={`${view === "list" ? styles.headerTitleCentered : ""} mediumLarge`}>
                                {view === "list" ? `Alle Equipments (${items.length})` : "Alle Equipments"}
                            </h2>
                        </>
                    )}
                </div>
                <div className={styles.headerSide}>
                    <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Schließen">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.50947 8.5L0 0.990535L0.990535 0L8.5 7.50947L16.0095 0L17 0.990535L9.49054 8.5L17 16.0095L16.0095 17L8.5 9.49054L0.990535 17L0 16.0095L7.50947 8.5Z" fill="#1F1F1F"/>
                        </svg>
                    </button>
                </div>
            </header>
            {view === "list" ? renderList() : renderDetail()}
        </div>
    );
};
